import React from 'react'
import GatsbyConfig from '../../../gatsby-config.js'

const { siteMetadata: config } = GatsbyConfig

export default class TripHeader extends React.Component {
  render() {
    const { trip } = this.props
    const tripData = config.trips[trip]

    return (
      <h1 className="trip-header">
        {`${tripData.location}`} | <time>{tripData.dates}</time>
      </h1>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/trip-header.js